import DTM from "shared/helpers/DTM";

export const updateAnalyticalData = (
    searchTerm: string,
    autoSuggestResult: object,
    searchType: string = "autocomplete"
) => {
    DTM.updateDatalayer({
        searchtype: searchType,
        searchTerm: searchTerm,
        autosuggestresult: autoSuggestResult,
    });
};
